
export default class logUtils{


  /**
   * 将日志内容转换为数组
   * @param str
   * @returns {*}
   */
  static tranLogContent(str) {
    if (str == null || str == undefined ||str == "" ){
      return [];
    }
    let arr = str.split(',');
    return arr;
  }
  /**
   * 将日志类型转换为数组
   * @param str
   * @returns {*}
   */
  static tranLogType(str) {
    if (str == null || str == undefined ||str == "" ){
      return [];
    }
    let arr = str.split(':');
    return arr;
  }
}



// WEBPACK FOOTER //
// ./src/utils/logUtils.js